import { useContext } from 'react';
import Context from '../contexts/InvitationContext';

export default () => useContext(Context);
